
/**
* @module core/api_error
*/
define('core/api_error',["require", "exports"], function(require, exports) {
    /**
    * Standard libc error codes. Add more to this enum and ErrorStrings as they are
    * needed.
    * @url http://www.gnu.org/software/libc/manual/html_node/Error-Codes.html
    */
    (function (ErrorCode) {
        ErrorCode[ErrorCode["EPERM"] = 0] = "EPERM";
        ErrorCode[ErrorCode["ENOENT"] = 1] = "ENOENT";
        ErrorCode[ErrorCode["EIO"] = 2] = "EIO";
        ErrorCode[ErrorCode["EBADF"] = 3] = "EBADF";
        ErrorCode[ErrorCode["EACCES"] = 4] = "EACCES";
        ErrorCode[ErrorCode["EBUSY"] = 5] = "EBUSY";
        ErrorCode[ErrorCode["EEXIST"] = 6] = "EEXIST";
        ErrorCode[ErrorCode["ENOTDIR"] = 7] = "ENOTDIR";
        ErrorCode[ErrorCode["EISDIR"] = 8] = "EISDIR";
        ErrorCode[ErrorCode["EINVAL"] = 9] = "EINVAL";
        ErrorCode[ErrorCode["EFBIG"] = 10] = "EFBIG";
        ErrorCode[ErrorCode["ENOSPC"] = 11] = "ENOSPC";
        ErrorCode[ErrorCode["EROFS"] = 12] = "EROFS";
        ErrorCode[ErrorCode["ENOTEMPTY"] = 13] = "ENOTEMPTY";
        ErrorCode[ErrorCode["ENOTSUP"] = 14] = "ENOTSUP";
    })(exports.ErrorCode || (exports.ErrorCode = {}));
    var ErrorCode = exports.ErrorCode;

    /**
    * Strings associated with each error code.
    */
    var ErrorStrings = {};
    ErrorStrings[0 /* EPERM */] = 'Operation not permitted.';
    ErrorStrings[1 /* ENOENT */] = 'No such file or directory.';
    ErrorStrings[2 /* EIO */] = 'Input/output error.';
    ErrorStrings[3 /* EBADF */] = 'Bad file descriptor.';
    ErrorStrings[4 /* EACCES */] = 'Permission denied.';
    ErrorStrings[5 /* EBUSY */] = 'Resource busy or locked.';
    ErrorStrings[6 /* EEXIST */] = 'File exists.';
    ErrorStrings[7 /* ENOTDIR */] = 'File is not a directory.';
    ErrorStrings[8 /* EISDIR */] = 'File is a directory.';
    ErrorStrings[9 /* EINVAL */] = 'Invalid argument.';
    ErrorStrings[10 /* EFBIG */] = 'File is too big.';
    ErrorStrings[11 /* ENOSPC */] = 'No space left on disk.';
    ErrorStrings[12 /* EROFS */] = 'Cannot modify a read-only file system.';
    ErrorStrings[13 /* ENOTEMPTY */] = 'Directory is not empty.';
    ErrorStrings[14 /* ENOTSUP */] = 'Operation is not supported.';

    /**
    * Represents a BrowserFS error. Passed back to applications after a failed
    * call to the BrowserFS API.
    */
    var ApiError = (function () {
        /**
        * Represents a BrowserFS error. Passed back to applications after a failed
        * call to the BrowserFS API.
        *
        * Error codes mirror those returned by regular Unix file operations, which is
        * what Node returns.
        * @constructor ApiError
        * @param type The type of the error.
        * @param [message] A descriptive error message.
        */
        function ApiError(type, message) {
            this.type = type;
            this.code = ErrorCode[type];
            if (message != null) {
                this.message = message;
            } else {
                this.message = ErrorStrings[type];
            }
        }
        /**
        * @return A friendly error message.
        */
        ApiError.prototype.toString = function () {
            return this.code + ": " + ErrorStrings[this.type] + " " + this.message;
        };

        ApiError.FileError = function (code, p) {
            return new ApiError(code, p + ": " + ErrorStrings[code]);
        };
        ApiError.ENOENT = function (path) {
            return this.FileError(1 /* ENOENT */, path);
        };

        ApiError.EEXIST = function (path) {
            return this.FileError(6 /* EEXIST */, path);
        };

        ApiError.EISDIR = function (path) {
            return this.FileError(8 /* EISDIR */, path);
        };

        ApiError.ENOTDIR = function (path) {
            return this.FileError(7 /* ENOTDIR */, path);
        };

        ApiError.EPERM = function (path) {
            return this.FileError(0 /* EPERM */, path);
        };
        return ApiError;
    })();
    exports.ApiError = ApiError;
});
//# sourceMappingURL=api_error.js.map
;